import React from 'react';
import './App.css';
import TypingEffectSequence from "./TypingEffectSequence";
function App() {
    const texts = [
        "Wake up, Neo...",
        "The Matrix has you...",
        "Follow the white rabbit.",
        "Knock, knock, Neo.",
        "The Matrix has enslaved us, but we are about to crash it.",
        "We've woke up, we fought, we are a legion, the saviors",
        "We are",
        "topmaterial"
    ];
    return (
        <div className="App">
            <TypingEffectSequence className="matrix-text"
                texts={texts}
                speed={100}
                color="#00FF00"
                fontFamily="MatrixCode"
                fontSize={30}
            />
        </div>
    );
}

export default App;
